<script lang="ts">
  import { getBorderColors, setFocus } from "../../helpers/helperMethods";

  interface Props {
    error?: boolean;
    value: string | undefined;
    name?: string;
    id?: string;
    autoFocus?: boolean;
    required?: boolean;
    disabled?: boolean;
    class?: string;
    hasPressedContinue?: boolean;
    tabindex?: number;
    ariaDescribedby?: string;
    onfocus?: (event: FocusEvent) => void;
    onblur?: (event: FocusEvent) => void;
  }

  let {
    error = false,
    value = $bindable(),
    name = undefined,
    id = undefined,
    autoFocus = false,
    required = true,
    disabled = false,
    class: className,
    hasPressedContinue = false,
    tabindex = 0,
    ariaDescribedby = undefined,
    onfocus = undefined,
    onblur = undefined,
  }: Props = $props();

  // Strip non-digits and cap at 5 — covers typing, paste ("931 87" → "93187"),
  // and programmatic writes. 
  // Skip while disabled: read-only inputs show fetched pinlookup values,
  // which the API masks for privacy (e.g. "9****").  
  $effect(() => {
    if (disabled) return;
    if (value === undefined || value === null) return;
    const digits = String(value).replace(/\D/g, "").slice(0, 5);
    if (digits !== value) value = digits;
  });

  const init = (el: any) => {
    if (autoFocus) {
      setFocus(el, false);
    }
  };
</script>

<input
  type="text"
  inputmode="numeric"
  autocomplete="postal-code"
  size={5}
  use:init
  bind:value
  {id}
  {name}
  {disabled}
  {tabindex}
  {onfocus}
  {onblur}
  aria-invalid={error}
  aria-describedby={ariaDescribedby}
  class="text-M h-10 p-2 rounded-md appearance-none {disabled
    ? 'bg-Neutral200 cursor-not-allowed text-Neutral700'
    : ''} {getBorderColors(
    error,
    value === undefined && !hasPressedContinue,
    disabled
  )} {className}"
  {required}
/>
